import React from 'react';
import { Switch, Button, Card, Checkbox, Col, Form, Icon, Input, message, Modal, Row, Select, DatePicker, TimePicker, Tooltip } from 'antd';
import { fetchEvt } from "../../redux/actions/evt";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { inEditMode } from "../../redux/actions/global";
import Iconfont from "../../components/Iconfont/Iconfont";
import { findEventCiFormPreset, updateEventCheckinForm,patchEventConfig } from "../../services/evt";
import { isValidity } from "../../services/global";
import styled from "styled-components";
import moment from 'moment';
import lodash from "lodash"
import PurchaseServiceTips from "../PurchaseServiceTips";
import YiDong from "../../style/imgs/yidong.png"
import evtConfigDes from './EvtConfigDes'
import CkInfoItem from "../../components/CkInfoItem";


const CiFormRow = styled(Row)`
    .ant-form-item{
      margin-bottom: 0;
    }
    .ant-form-explain{
      display: none;
    }
    .ant-form-inline{
      .ant-form-item{
        display:block;
        margin-bottom: 8px;
        }
      
    }

`

const PresetView = styled.div`
    display: flex;
    flex-wrap: nowrap;
    justify-content:flex-start;
    .cifield-unique{
      width:70px;
    }
    .cifield-require{
      width:70px;
    }
   
`
const Preset = styled.div`
    // background:  url(${YiDong}) no-repeat 0 6px;
    background-size: 20px auto;
    // padding-left:30px;
    margin-bottom: 18px;
    display: flex;
    flex-wrap: nowrap;
    justify-content:flex-start;
    &:hover {
      cursor: move;
    }
    .cifield-move{
      width:30px;
      display: none;
      flex-shrink:0;
    }
    .cifield-require{
      width:70px;
      margin-top: 5px;
      flex-shrink:0;
    }
    .cifield-hide{
      display: none;
    }
    .cifield-tools{
       width:100px;
       flex-shrink:0;
       margin-top: 5px;
       padding: 0 15px;
       font-size: 14px;
       a{
        margin-right:8px;
       }
    }
    .cifield-mc{
      width: 100%;
      >.ant-input-group-wrapper{
         margin-bottom: 5px;
      }
      .ffoptions{
          margin-top: 3px;
      }
      .ffoption{
          display: flex;
          flex-wrap: nowrap;
          align-items: baseline;
          margin-bottom: 3px;
          >.minput{
            // width:80%;
          }
      }
      .ffoption-tools{
        >a{
          padding-left: 8px;
          .anticon{
            font-size: 14px;
            margin-right: 10px;
          }
          font-size: 13px;
        }
      }
     
    }
   
`


const PresetWrap = styled.div`
    display: flex;
    flex-wrap: wrap;
     justify-content:space-around;
    &>button, &>.placeholderdiv{
      width: 75px;
      padding: 0 3px;
      margin:3px 3px;
    }
`

const CustomPresetWrap = styled.div`
   &>button{
      width:100%;
      padding: 0 3px;
      margin:3px 3px;
   }
`

class EvtViewCheckinForm extends React.Component {

    componentDidUpdate() {

    }

    constructor(props) {
        super(props);
        this.state = {
            erfChecked:props.evt.config.enableReplenishForm,
            formLoading: false,
            preset: [],
        }
    }


    componentDidMount() {
        findEventCiFormPreset().then(res => {
            if (res.code == 200) {
                this.setState({
                    preset: res.data
                })
            } else {
                message.error(res.msg,6);
            }
        }).catch(err => {
            message.warn("访问异常");
        })

        isValidity('WXCHECKINZEROINPUT', (vaild) => {
            this.setState({
                validity: vaild
            })
        })
    }




    save = () => {
        this.props.form.validateFieldsAndScroll((error, values) => {
            if (!error) {
                //去除_开头的属性(为了动态字段添加的)
                var _values = { ...values };
                Object.keys(_values).forEach((key) => {
                    if (key != "fields" && key.startsWith("_")) {
                        delete _values[key]
                    }
                })
                _values.fields = _values.fields ? _values.fields : [];
                _values.fields.forEach((obj, index) => {
                    obj.seq = index + 1;
                })
                if(_values.fields.length == 0 && this.state.erfChecked){
                    message.error('需要添加表单字段才能开启此功能！');
                    return;
                }
                updateEventCheckinForm(Object.assign({ eventId: this.props.evt.config.replenishFormEventId }, _values)).then(res => {
                    if (res.code == 200) {
                        patchEventConfig(Object.assign({id: this.props.evt.header.id}, {enableReplenishForm:this.state.erfChecked})).then(res => {
                            if (res.code == 200) {
                                message.info("更新成功!");
                                this.props.editableChange(this.props.editableStatePropName, false, true)
                            } else {
                                message.error(res.msg,6);
                            }
                        }).catch(err => {
                            message.warn("访问异常");
                        })
                    } else {
                        message.error(res.msg,6);
                    }
                }).catch(err => {
                    message.warn("访问异常");
                }).finally(() => {
                    this.changeFormLoading(false)
                })
                console.log('success', _values);
            } else {
                console.log('error', error, values);
            }
        });
    }

    changeFormLoading = (loading) => {
        this.setState({
            formLoading: loading
        })
    }

    handleOk = () => {
        this.changeFormLoading(false)
        this.props.editableChange(this.props.editableStatePropName, false)
    }
    handleCancel = () => {
        this.changeFormLoading(false)
        this.props.editableChange(this.props.editableStatePropName, false)
    }

    addField = (fieldName, value = {}) => {
        const { form } = this.props;
        var fieldsValue = form.getFieldsValue();
        var _fieldVal = lodash.get(fieldsValue, `_${fieldName}`);
        _fieldVal.push(value);

        lodash.set(fieldsValue, `_${fieldName}`, _fieldVal);

        form.setFieldsValue(fieldsValue);
    }

    removeField = (fieldName, index) => {
        const { form } = this.props;
        var fieldsValue = form.getFieldsValue();
        let fieldVal = lodash.get(fieldsValue, fieldName);
        let _fieldVal = lodash.get(fieldsValue, `_${fieldName}`);
        fieldVal.splice(index, 1);
        _fieldVal.splice(index, 1);

        lodash.set(fieldsValue, `_${fieldName}`, _fieldVal);
        lodash.set(fieldsValue, fieldName, fieldVal);

        form.setFieldsValue(fieldsValue);


    }
    updateField = (fieldName, index, value) => {
        const { form } = this.props;
        var fieldsValue = form.getFieldsValue();
        lodash.set(fieldsValue, `_${fieldName}[${index}].enableTimeControl`, value);
        // lodash.set(fieldsValue, `${fieldName}[${index}]`, value);

        form.setFieldsValue(fieldsValue);

    }

    //移动
    moveQuestionsItem = (index, type) => {
        const { setFieldsValue, getFieldsValue } = this.props.form;
        let fieldsValue = getFieldsValue();
        let columns = fieldsValue._fields;
        let columns1 = fieldsValue.fields;
        let from = index;
        let to = type == 'up' ? index - 1 : index + 1;
        if (columns[index].type == 'MULTIPLECHOICE' || columns[index].type == 'SINGLECHOICE') {
            columns[index].options = columns1[index].options;
        }

        // if (from < to) to--;
        columns.splice(to, 0, columns.splice(from, 1)[0]);
        columns1.splice(to, 0, columns1.splice(from, 1)[0]);
        setFieldsValue(fieldsValue);
    }

    render() {
        const evt = this.props.evt;
        const evtFields = evt.replenishForm ? evt.replenishForm.fields : [];

        const { getFieldDecorator, getFieldValue, getFieldError, setFieldsValue, getFieldsValue } = this.props.form;

        getFieldDecorator('_fields', { initialValue: evtFields.map(f => f) });
        const _fields = getFieldValue('_fields') ? getFieldValue('_fields') : [];
        const fields = getFieldValue('fields') ? getFieldValue('fields') : [];
        console.log(_fields)
        const formItemLayoutFileds = {
            labelCol: {
                xs: { span: 2 },
                sm: { span: 2 },
            },
            wrapperCol: {
                xs: { span: 20 },
                sm: { span: 20 },
            },
        };

        return (
            <Form>
                <div>
                    {
                        evtFields.map((f, index) => {
                            return (
                                <PresetView key={`adsfa1134sdf${index}`}>

                                    <div className="cifield-require">
                                        {f.required ? "必填" : ""}
                                    </div>
                                    <div className="cifield-mc">
                                        {f.name}
                                    </div>
                                </PresetView>
                            )
                        })
                    }
                </div>
                <Modal
                    visible={this.props.editable}
                    title="编辑签到信息补充表"
                    width="850px"
                    maskClosable={false}
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}
                    footer={[
                        <Button key="back" onClick={this.handleCancel}>
                            放弃
                        </Button>,
                        <Button key="submit" type="primary" loading={this.state.formLoading} onClick={this.save}>
                            保存
                        </Button>,
                    ]}
                >
                    <CiFormRow>
                        <Col span={24}>
                            {
                                [evtConfigDes.enableReplenishForm].map((conf, index) => (
                                    <CkInfoItem
                                        key={`${conf.fieldName}${index}`}
                                        label={
                                            <div>
                                                {conf.name}
                                                <Tooltip placement="bottom" overlayClassName='overlay-image'
                                                    mouseEnterDelay={0.3} title={
                                                        <div style={{ overflow: 'auto' }} dangerouslySetInnerHTML={{ __html: conf.help }}></div>
                                                    }>
                                                    <span title="" style={{ marginLeft: "3px" }}><Icon
                                                        type="question-circle-o" /></span>
                                                </Tooltip>
                                            </div>
                                        }
                                        contentIndent={false}
                                    >
                                        <Switch 
                                            checked={this.state.erfChecked}
                                            checkedChildren={conf.switch[0]}
                                            unCheckedChildren={conf.switch[1]}
                                            onChange={(checked) => {
                                                let _checked = checked;
                                                if(!this.state.validity && checked){
                                                    _checked = false;
                                                    this.pstView.show();
                                                }
                                                this.setState({erfChecked:_checked})
                                             }}
                                        />
                                    </CkInfoItem>

                                ))
                            }
                        </Col>
                        <Col span={24}>
                            <Card noHovering={true} bodyStyle={{ padding: "15px 22px" }}>
                                {/* <Alert message={<div>
                
                                </div>} type="info"/> */}
                                <h3>
                                    <div className="ant-form ant-form-inline">
                                        <Form.Item
                                            {...formItemLayoutFileds}
                                            label="标题"
                                        >
                                            {getFieldDecorator(`name`, {
                                                initialValue: evt.replenishForm ? evt.replenishForm.name : '',
                                                rules: [{ required: false }, { min: 2, max: 40, message: '长度限制为2至40个之间!' }],

                                            })(
                                                <Input placeholder="标题，如：区域防疫检查点" />
                                            )}
                                        </Form.Item>
                                        <Form.Item
                                            {...formItemLayoutFileds}
                                            label="说明"
                                        >
                                            {getFieldDecorator(`summary`, {
                                                initialValue: evt.replenishForm ? evt.replenishForm.summary : '',
                                                rules: [{ required: false }, { min: 2, max: 200, message: '长度限制为2至200个之间!' }],
                                            })(
                                                <Input.TextArea autosize={{ minRows: 2, maxRows: 3 }} placeholder="说明，如：请大家如实填写上报自己体温，谢谢" />
                                            )}
                                        </Form.Item>
                                    </div>
                                </h3>
                            </Card>
                        </Col>

                        <Col span={16}
                            // onDragOver={this.columnsControlItemDragOver}
                            className='field-container'>
                            {
                                _fields.map((f, findex) => {
                                    var desComp = null;
                                    var typeDes = "文本框";
                                    var display = true;
                                    var dateTime = false;
                                    if (f.type == "TEXT") {
                                        if (f.constraint) {
                                            if (lodash.startsWith(f.constraint, "img")) {
                                                typeDes = <span>
                                                    {/*<Icon type="picture" />*/}
                                                    图 片</span>
                                            } else if (lodash.startsWith(f.constraint, "mobile")) {
                                                typeDes = <span>
                                                    {/*<Icon type={'mobile'}/>*/}
                                                    手 机</span>
                                            } else if (lodash.startsWith(f.constraint, "email")) {
                                                typeDes = <span>
                                                    {/*<Icon type="mail" />*/}
                                                    邮 箱</span>
                                            } else if (lodash.startsWith(f.constraint, "multipletext")) {
                                                typeDes = "多行文本"
                                            } else if (lodash.startsWith(f.constraint, "date")) {
                                                typeDes = "日 期";
                                                dateTime = true;
                                                desComp = (f.enableTimeControl && <div className={"ffoptions"}>
                                                    <div className={"ffoption"}>
                                                        <div className="cifield-hide">

                                                        </div>
                                                        <div className="minput">
                                                            <Form.Item style={{ display: 'inline-block', marginRight: 8 }}>
                                                                {getFieldDecorator(`fields[${findex}].start`, {
                                                                    initialValue: f.start ? moment(f.start) : null,
                                                                    rules: [{ required: true }],
                                                                })(
                                                                    <DatePicker placeholder="开始范围" style={{ width: 105 }} />
                                                                )}
                                                            </Form.Item>
                                                            <Form.Item style={{ display: 'inline-block', }}>
                                                                {getFieldDecorator(`fields[${findex}].end`, {
                                                                    initialValue: f.end ? moment(f.end) : null,
                                                                    rules: [{ required: true }],
                                                                })(
                                                                    <DatePicker placeholder="结束范围" style={{ width: 105 }} />
                                                                )}
                                                            </Form.Item>
                                                        </div>
                                                    </div>
                                                </div>)
                                            } else if (lodash.startsWith(f.constraint, "time")) {
                                                typeDes = "时 间";
                                                dateTime = true;
                                                desComp = (f.enableTimeControl && <div className={"ffoptions"}>
                                                    <div className={"ffoption"}>
                                                        <div className="cifield-hide">

                                                        </div>
                                                        <div className="minput">
                                                            <Form.Item style={{ display: 'inline-block', marginRight: 8 }}>
                                                                {getFieldDecorator(`fields[${findex}].start`, {
                                                                    initialValue: f.start ? moment(f.start, 'HH:mm') : null,
                                                                    rules: [{ required: true }],
                                                                })(
                                                                    <TimePicker format={'HH:mm'} placeholder="开始范围" style={{ width: 105 }} />
                                                                )}
                                                            </Form.Item>
                                                            <Form.Item style={{ display: 'inline-block', }}>
                                                                {getFieldDecorator(`fields[${findex}].end`, {
                                                                    initialValue: f.end ? moment(f.end, 'HH:mm') : null,
                                                                    rules: [{ required: true }],
                                                                })(
                                                                    <TimePicker format={'HH:mm'} placeholder="结束范围" style={{ width: 105 }} />
                                                                )}
                                                            </Form.Item>
                                                        </div>
                                                    </div>
                                                </div>)
                                            } else if (lodash.startsWith(f.constraint, "address")) {
                                                typeDes = "省市区"
                                            } else if (lodash.endsWith(f.constraint, "^([a-zA-z]+://[^s]*)$")) {
                                                typeDes = "网 址"
                                            } else if (lodash.endsWith(f.constraint, "^(\\d{6})(\\d{4})(\\d{2})(\\d{2})(\\d{3})([0-9]|X)$")) {
                                                typeDes = "身份证"
                                            }

                                        }
                                    } else if (f.type == "SINGLECHOICE") {
                                        typeDes = "单选题"
                                        display = false;
                                        desComp = <div className={"ffoptions"}>{
                                            f.options.map((opt, oindex) => {
                                                return (
                                                    <div className={"ffoption"} key={`aaaasd23233782-${oindex}`}>
                                                        <div className="cifield-hide">
                                                            {getFieldDecorator(`fields[${findex}].options[${oindex}].id`, {
                                                                initialValue: opt.id,
                                                                rules: [{ required: false }],
                                                            })(
                                                                <Input />
                                                            )}

                                                        </div>
                                                        <div className="minput">
                                                            <Form.Item style={{ display: 'inline-block', marginRight: 8 }}>
                                                                {getFieldDecorator(`fields[${findex}].options[${oindex}].name`, {
                                                                    initialValue: opt.name,
                                                                    rules: [{ required: true, whitespace: true }, { whitespace: true, message: '不能输入空格!' }, { min: 1, max: 100, message: '长度限制为1至100个之间!' }],
                                                                })(
                                                                    <Input addonBefore={<span className="ant-radio-inner"></span>} addonAfter={
                                                                        oindex > 1 ? <a onClick={() => this.removeField(`fields[${findex}].options`, oindex)}><Icon type={"close-circle-o"} /></a> : null
                                                                    } />
                                                                )}
                                                            </Form.Item>

                                                        </div>
                                                    </div>
                                                )
                                            })
                                        }
                                            <div className="ffoption-tools">
                                                <a onClick={() => this.addField(`fields[${findex}].options`, { name: `子项目` })}><Icon type={"plus-circle-o"} />添加选项</a>
                                            </div>
                                        </div>
                                    } else if (f.type == "MULTIPLECHOICE") {
                                        typeDes = "多选题"
                                        display = false;
                                        desComp = <div className={"ffoptions"}>{
                                            f.options.map((opt, oindex) => {
                                                return (
                                                    <div className={"ffoption"} key={`sj480kc${oindex}a8`}>
                                                        <div className="cifield-hide">
                                                            {getFieldDecorator(`fields[${findex}].options[${oindex}].id`, {
                                                                initialValue: opt.id,
                                                                rules: [{ required: false }],
                                                            })(
                                                                <Input />
                                                            )}

                                                        </div>
                                                        <div className="minput">
                                                            <Form.Item style={{ display: 'inline-block', marginRight: 8 }}>
                                                                {getFieldDecorator(`fields[${findex}].options[${oindex}].name`, {
                                                                    initialValue: opt.name,
                                                                    rules: [{ required: true, whitespace: true }, { whitespace: true, message: '不能输入空格!' }, { min: 1, max: 100, message: '长度限制为1至100个之间!' }],
                                                                })(
                                                                    <Input addonBefore={<span className="ant-checkbox-inner"></span>} addonAfter={
                                                                        oindex > 1 ? <a onClick={() => this.removeField(`fields[${findex}].options`, oindex)}><Icon type={"close-circle-o"} /></a> : null
                                                                    } />
                                                                )}
                                                            </Form.Item>
                                                        </div>
                                                    </div>
                                                )
                                            })
                                        }
                                            <div className="ffoption-tools">
                                                <a onClick={() => this.addField(`fields[${findex}].options`, { name: `子项目` })}><Icon type={"plus-circle-o"} />添加选项</a>
                                            </div>
                                        </div>

                                    }

                                    return (
                                        <Preset className='field-item'
                                            // draggable="true"
                                            // data-index={findex}
                                            // onDragEnd={this.columnsControlItemDragEnd}
                                            // onDragStart={this.columnsControlItemDragStart}
                                            key={`adsf345345a1134sdf${findex}`}>

                                            <div className="cifield-move">
                                                <Iconfont libname="ckicon" type="move" />
                                            </div>

                                            <div className="cifield-require">
                                                {getFieldDecorator(`fields[${findex}].required`, {
                                                    initialValue: f.required,
                                                    valuePropName: 'checked',
                                                    rules: [{ required: false }],
                                                })(
                                                    <Checkbox >必填</Checkbox>
                                                )}

                                            </div>

                                            <div className="cifield-hide">
                                                {getFieldDecorator(`fields[${findex}].id`, {
                                                    initialValue: f.id,
                                                    rules: [{ required: false }],
                                                })(
                                                    <Input />
                                                )}
                                                {getFieldDecorator(`fields[${findex}].type`, {
                                                    initialValue: f.type,
                                                    rules: [{ required: false }],
                                                })(
                                                    <Input />
                                                )}
                                                {getFieldDecorator(`fields[${findex}].constraint`, {
                                                    initialValue: f.constraint,
                                                    rules: [{ required: false }],
                                                })(
                                                    <Input />
                                                )}

                                            </div>
                                            <div className="cifield-mc">
                                                <Form.Item>
                                                    {getFieldDecorator(`fields[${findex}].name`, {
                                                        initialValue: f.name,
                                                        rules: [{ required: true, whitespace: true }, { whitespace: true, message: '不能输入空格!' }, { min: 1, max: 100, message: '长度限制为1至100个之间!' }],
                                                    })(
                                                        <Input addonAfter={typeDes} />
                                                    )}
                                                    {desComp}
                                                </Form.Item>
                                            </div>
                                            <div className="cifield-tools">
                                                {findex != 0 &&
                                                    <a onClick={() => this.moveQuestionsItem(findex, 'up')}><Icon type="arrow-up" /></a>}
                                                {findex != _fields.length - 1 &&
                                                    <a onClick={() => this.moveQuestionsItem(findex, 'down')}><Icon type="arrow-down" /></a>}
                                                <a onClick={() => this.removeField(`fields`, findex)}><Icon type={"delete"} /></a>
                                            </div>
                                        </Preset>
                                    )
                                })
                            }
                        </Col>
                        <Col span={8}>
                            <Card noHovering={true}>
                                <h3>
                                    常用项
                                </h3>
                                <PresetWrap>
                                    {
                                        this.state.preset.filter(f=>!lodash.startsWith(f.constraint, "dropdown")).map((p, index) => {
                                            return <Button key={`kljsdklfjklasdf-${index}`} onClick={() => {
                                                this.addField(`fields`, p)
                                            }}>{p.name}</Button>
                                        })
                                    }
                                    {
                                        this.state.preset.length == 0 ? null : Array.from(Array(3 - (this.state.preset.length % 3)).keys()).map((a, index) => <div key={`ooyp556v363c${index}`} className="placeholderdiv">&nbsp;</div>)
                                    }
                                </PresetWrap>

                                <h3 style={{ marginTop: 20 }}>
                                    自定义项
                                </h3>

                                <CustomPresetWrap>
                                    <Button onClick={() => this.addField(`fields`, { type: "TEXT", name: `文本框`, hidden: false, required: false })}>文本框</Button>
                                    <Button onClick={() => this.addField(`fields`, { type: "TEXT", name: `文本框`, constraint: "multipletext:", hidden: false, required: false })}>多行文本</Button>
                                    <Button onClick={() => this.addField(`fields`, { type: "SINGLECHOICE", name: `单选题`, hidden: false, required: false, options: [{ name: "子项目", hidden: false }, { name: "子项目", hidden: false }] })}>单选题</Button>
                                    <Button onClick={() => this.addField(`fields`, { type: "MULTIPLECHOICE", name: `多选题`, hidden: false, required: false, options: [{ name: "子项目", hidden: false }, { name: "子项目", hidden: false }] })}>多选题</Button>
                                </CustomPresetWrap>
                            </Card>
                        </Col>
                    </CiFormRow>

                </Modal>

                <PurchaseServiceTips
                    ref={(pst) => {
                        this.pstView = pst
                    }}
                    member={this.state.isMember ? 'MEMBER' : 'SENIORMEMBER'}

                />
            </Form>
        )
    }
}

const mapStateToPorps = state => {
    const cmEnums = state.cmEnums;
    return { cmEnums };
};
const mapDispatchToProps = dispatch => ({
    fetchEvt: bindActionCreators(fetchEvt, dispatch),
});

EvtViewCheckinForm.contextTypes = {}

EvtViewCheckinForm.defaultProps = {
    evt: {},
    editable: false,
    editableStatePropName: "ticketEditable",
    editableChange: (editable, dataChanged = false) => null,
}

EvtViewCheckinForm.propTypes = {}


export default connect(mapStateToPorps, mapDispatchToProps)(Form.create()(EvtViewCheckinForm));


// WEBPACK FOOTER //
// ./src/containers/evt/EvtViewCheckinForm.jsx